export default "__VITE_ASSET__e54f0663__"